/*jshint esversion:6 */
import React from "react";
import Select from "react-select";
import Breadcrumbs from "react-breadcrumbs";
import Toaster from "toastr";
import { connect } from "react-redux";
import { Permissioned } from "react-permissions";
import Divider from "../../common/divider";
import PageTitle from "../../common/pageTitle";
import Util from "../../../util/util";
import Messages from "../../../configurations/messages";
import Permissions from "../../../configurations/permissions";
import Constants from "../../../configurations/constants";
import ArbiterApi from "../../../api/ArbiterApi";
import ReasonCodesTable from "./reasonCodesTable";
import ReasonCodesModal from "./reasonCodesModal";

class ReasonCodesPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      reasonCodes: [],
      selectedReasonCode: null,
      totalCount: 0,
      loading: false,
      pages: 0,
      openModalFlag: false,
      createFlag: false,
      pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
      pageNum: 0 //Zero based index
    };
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.onNewButtonClick = this.onNewButtonClick.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.paginateid = this.paginateid.bind(this);
  }

  componentDidMount() {
    //Get Dispute Categories
    ArbiterApi.getDisputeCategories()
      .then(response => {
        let categories = response.data.map(obj => {
          obj.label = obj.category;
          obj.value = obj.category;
          obj.statuses = obj.statuses.map(status => {
            return {
              label: status,
              value: status
            };
          });

          return obj;
        });

        this.setState({ categories });
      })
      .catch(error => {
        console.log(error);
        return `${Messages.ERROR_DISPUTE_CATEGORIES} -  ${
          error.data ? error.data.description : error.statusText
        }`;
      });

    //Load data on mount
    this.reloadCodes();
  }

  onNewButtonClick(evt) {
    this.setState({ openModalFlag: true, createFlag: true });
  }
  handleFilterChange(evt) {
    this.setState({ category: evt, pageNum: 0 }, () => this.reloadCodes());
  }
  paginateid(index) {
    const offset = parseInt(this.state.pageNum, 0);
    //const idx = parseInt(index, 0);
    const pagesize = parseInt(this.state.pageSize, 0);
    const result = offset * pagesize + index + 1;
    return result.toString();
  }

  render() {
    return (
      <div>
        <div id="page-breadcrumb" className="breadcrumb-container">
          <Breadcrumbs
            separator={Constants.BREADCRUMB_SEPARATOR}
            routes={this.props.routes}
            params={this.props.params}
          />
        </div>
        <PageTitle title="Reason Codes" />
        <Divider />
        <div className="mini-filter">
          <div className="right">
            <br />
            <button
              onClick={this.onNewButtonClick}
              className="btn btn-primary right"
            >
              + New Reason Code
            </button>
          </div>
          <div className="filter-select">
            <label className="input-control-label">Dispute Category</label>
            <Select
              placeholder="Dispute Category"
              onChange={this.handleFilterChange}
              options={this.state.categories}
              value={this.state.category}
            />
          </div>
        </div>
        <ReasonCodesTable
          onRowClick={this.onRowClick}
          loading={this.state.loading}
          onTableChange={this.onTableChange}
          page={this.state.pageNum}
          pages={this.state.pages}
          defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
          reasonCodes={this.state.reasonCodes}
          paginatedCallback={this.paginateid}
        />
        {this.state.openModalFlag && (
          <ReasonCodesModal
            isNew={this.state.createFlag}
            isOpen={this.state.openModalFlag}
            onRequestClose={this.handleCloseModal}
            reasonCode={this.state.selectedReasonCode}
          />
        )}
      </div>
    );
  }

  onTableChange(state, instance) {
    let pageSize = instance.state.pageSize;
    let pageNum = instance.state.page; //table page  - Zero based index
    this.setState({ pageSize: pageSize, pageNum: pageNum });
    if (this.state.filterParams) {
      let params = Util.clone(this.state.filterParams);
      params.pageSize = pageSize;
      params.pageNum = pageNum + 1;

      this.loadCodes(params);
    }
  }

  loadCodes(params, resetPageNumber) {
    //Reset states
    let stateUpdate = { loading: true, reasonCodes: [] };
    if (resetPageNumber) {
      stateUpdate.pageNum = 0;
      params.pageNum = 1;
    }
    this.setState(stateUpdate);
    params.pageSize = params.pageSize || this.state.pageSize;
    params.pageNum = params.pageNum || this.state.pageNum + 1;

    let category = this.state.category;

    if (category && category.value) {
      params.disputeCategory = category.value;
    }
    ArbiterApi.getReasonCodes(params)
      .then(response => {
        let data = response.data.content;
        let totalCount = response.data.count;
        let pages = totalCount
          ? Math.ceil(
              totalCount /
                (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)
            )
          : 0;
        if (data.length === 0)
          Toaster.warning("No records found.", "Reason Codes");
        this.setState({
          reasonCodes: data,
          loading: false,
          filterParams: params,
          totalCount: totalCount,
          pages: pages
        });
      })
      .catch(error => {
        console.log(error);
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_REASON_CODES}`
        ]);
        this.setState({ loading: false });
      });
  }

  onRowClick(index) {
    this.setState({
      selectedReasonCode: this.state.reasonCodes[index],
      openModalFlag: true,
      createFlag: false
    });
  }
  handleCloseModal(event, reloadDataFlag) {
    this.setState({
      selectedReasonCode: null,
      openModalFlag: false,
      createFlag: false
    });
    if (reloadDataFlag) {
      this.reloadCodes();
    }
  }

  reloadCodes() {
    this.setState({ reasonCodes: [] });
    this.loadCodes({ pageSize: this.state.pageSize });
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(ReasonCodesPage, [Permissions.VIEW_REASON_CODE])
);



// WEBPACK FOOTER //
// ./src/components/admin/reasonCodes/reasonCodesPage.js